module.exports = __webpack_public_path__ + "img/mxt.d8c1a271.jpg";